// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuControlPage {
  padding-left: 281px;
  background: #EFF0F4;
  width: 100%;
  height: 100vh;
}
@media (max-width: 900px) {
  .MenuControlPage .menu-control-page-container {
    padding-left: 20px !important;
  }
}
.MenuControlPage .PageContent {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 56px;
}
.MenuControlPage .PageContent .emptyList {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.MenuControlPage .PageContent .LoaderContainer {
  min-height: 487px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.MenuControlPage .PageContent .CardsContent {
  padding-left: 20px;
  padding-top: 20px;
  background: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 36px;
}
.MenuControlPage .PageContent .FirstControlPanel {
  display: flex;
  gap: 40px;
}
.MenuControlPage .PageContent .SecondControlPanelWrapper {
  display: flex;
  gap: 48px;
}
.MenuControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.1s;
}
.MenuControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover {
  color: rgb(173, 164, 164);
}
.MenuControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover svg path {
  transition: 0.1s;
  fill: rgb(173, 164, 164);
}

@media (max-width: 900px) {
  .menu-control-page {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/MenuControlPage/MenuControlPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AACF;AAEI;EADF;IAEI,6BAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAAN;AAGI;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AADN;AAII;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AAFN;AAKI;EACE,aAAA;EACA,SAAA;AAHN;AAMI;EACE,aAAA;EACA,SAAA;AAJN;AAKM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAHR;AAIQ;EACE,yBAAA;AAFV;AAIY;EACE,gBAAA;EACA,wBAAA;AAFd;;AAYE;EADF;IAEI,sBAAA;EARF;AACF","sourcesContent":[".MenuControlPage {\r\n  padding-left: 281px;\r\n  background: #EFF0F4;\r\n  width: 100%;\r\n  height: 100vh;\r\n\r\n  .menu-control-page-container {\r\n    @media (max-width: 900px) {\r\n      padding-left: 20px !important;\r\n    }\r\n  }\r\n\r\n  .PageContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 32px;\r\n    margin-top: 56px;\r\n\r\n    .emptyList {\r\n      display: flex;\r\n      align-items: center;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      gap: 20px;\r\n    }\r\n\r\n    .LoaderContainer {\r\n      min-height: 487px;\r\n      height: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-direction: column;\r\n      align-items: center;\r\n    }\r\n\r\n    .CardsContent {\r\n      padding-left: 20px;\r\n      padding-top: 20px;\r\n      background: white;\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-direction: column;\r\n      gap: 36px;\r\n    }\r\n\r\n    .FirstControlPanel {\r\n      display: flex;\r\n      gap: 40px;\r\n    }\r\n\r\n    .SecondControlPanelWrapper {\r\n      display: flex;\r\n      gap: 48px;\r\n      .SecondControlPanelContent {\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        transition: 0.1s;\r\n        &:hover {\r\n          color: rgb(173, 164, 164);\r\n          svg {\r\n            path {\r\n              transition: 0.1s;\r\n              fill: rgb(173, 164, 164);\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.menu-control-page {\r\n  @media (max-width: 900px) {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MenuControlPage": `MenuControlPage`,
	"menu-control-page-container": `menu-control-page-container`,
	"PageContent": `PageContent`,
	"emptyList": `emptyList`,
	"LoaderContainer": `LoaderContainer`,
	"CardsContent": `CardsContent`,
	"FirstControlPanel": `FirstControlPanel`,
	"SecondControlPanelWrapper": `SecondControlPanelWrapper`,
	"SecondControlPanelContent": `SecondControlPanelContent`,
	"menu-control-page": `menu-control-page`
};
export default ___CSS_LOADER_EXPORT___;
